<template>
  <div
    class="label-date-field label-date-field--glass"
    :class="[
      {
        'label-date-field--flex': flex,
        'label-date-field--error': hasError,
        'label-date-field--no-label': hideLabel,
      },
      customClass,
    ]"
  >
    <span v-if="!hideLabel" :id="labelId" class="label-date-field__label">
      {{ label }}<span v-if="required" class="label-date-field__required" aria-hidden="true">*</span>
    </span>
    <div class="label-date-field__control">
      <DatePicker
        :model-value="modelValue"
        :placeholder="placeholder"
        :readonly="readonly || disabled"
        @update:model-value="onUpdate"
        @change="onChange"
      />
    </div>
    <div v-if="$slots.default" class="label-date-field__messages">
      <slot />
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';

export default {
  name: 'LabelDateField',
  components: {
    DatePicker,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    /** When true, hides the visible label (use `label` or `ariaLabel` for accessibility). */
    hideLabel: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'MM/DD/YYYY',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    labelId() {
      return `${this.inputId}-label`;
    },
  },
  methods: {
    onUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style src="../styles/LabelDateField.css"></style>
